import * as ActivityActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'sentDate', order: 'descending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManageScheduledEmail = {
  items: [],
  params: defaultParams
};

const ActivityState = {
  ManageScheduledEmail: ManageScheduledEmail
};

export default function ActivityStore(state = ActivityState, action) {
  switch (action.type) {
    case ActivityActionType.SEARCH_SCHEDULED_EMAIL_SUCCESS:
      return processSearchSuccess(state, action);
    case ActivityActionType.RESET_SCHEDULED_EMAIL:
      return {
        ...state,
        ManageScheduledEmail: ManageScheduledEmail
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageScheduledEmail = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageScheduledEmail: manageScheduledEmail
  };
};



// WEBPACK FOOTER //
// ./src/Activities/reducers.js